import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useAccessoryCardStyles = makeStyles({
    root: {
        marginBottom: '20px',
        backgroundColor: tokens.colorNeutralBackground4,
        ...shorthands.padding('28px')
    },
    accessoryWrapper: {
        display: 'flex',
        flexDirection: 'row',
        '@media screen and (max-width: 780px)': {
            flexWrap: 'wrap'
        }
    },
    image: {
        height: '100%',
        maxWidth: '100%'
    },
    imageContainer: {
        width: '100px',
        height: '100px',
        display: 'flex',
        justifyContent: 'center',
        flexShrink: '0',
        alignItems: 'center',
        ...shorthands.padding('5px', '10px', '5px', '0px')
    },
    title: {
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.lineHeightBase500
    },
    info: {
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.lineHeightBase500,
        ...shorthands.margin('0')
    },
    itemInfoLabel: {
        fontSize: tokens.fontSizeBase300,
        ...shorthands.margin('0')
    },
    deleteIcon: {
        boxSizing: 'border-box',
        color: tokens.colorNeutralForeground4,
        display: 'flex',
        width: '20px',
        height: '20px',
        ...shorthands.margin('6px', '0'),
        cursor: 'pointer'
    },
    detailsWrapper: {
        justifyContent: 'flex-start',
        flexGrow: '1',
        '@media screen and (max-width: 550px)': {
            flexDirection: 'column',
            ...shorthands.flex(1)
        }
    },
    dueToday: {
        textAlign: 'right',
        justifyContent: 'end',
        marginRight: tokens.spacingHorizontalXXXL,
        '@media screen and (max-width: 550px)': {
            justifyContent: 'end'
        },
        '@media screen and (max-width: 780px)': {
            ...shorthands.flex(1),
            marginRight: tokens.spacingHorizontalNone
        }
    },
    removeItemContainer: {
        '@media screen and (max-width: 780px)': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: tokens.spacingVerticalL
        }
    },
    removeLabel: {
        marginLeft: tokens.spacingHorizontalS,
        color: tokens.colorNeutralStroke1,
        order: '1',
        '@media screen and (min-width: 780px)': {
            display: 'none'
        }
    },
    mobileLineBreak: {
        '@media screen and (max-width: 780px)': {
            width: '100%'
        }
    }
});
